module.exports = __webpack_public_path__ + "static/media/img-reason-deal@2x.64bf30e6.png";